import { render, staticRenderFns } from "./ItemListPage.vue?vue&type=template&id=722f2d46&"
import script from "./ItemListPage.vue?vue&type=script&lang=ts&"
export * from "./ItemListPage.vue?vue&type=script&lang=ts&"
import style0 from "./ItemListPage.vue?vue&type=style&index=0&id=722f2d46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports